import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/LayoutFlex.scss';

export default function LayoutFlex({
    children,
    className,
    float,
    ...props
}) {
    const classes = classNames(styles[float], className);
    return (
        <div {...props} className={classes}>
            {children}
        </div>
    );
}

LayoutFlex.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    float: PropTypes.oneOf(['left', 'right']).isRequired,
};
